import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDashboardFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.802 15.5H5.198A2.7 2.7 0 0 0 2.5 18.198v.604A2.7 2.7 0 0 0 5.198 21.5h2.604a2.7 2.7 0 0 0 2.698-2.698v-.604A2.7 2.7 0 0 0 7.802 15.5M18.802 2.5h-2.604A2.7 2.7 0 0 0 13.5 5.198v.604A2.7 2.7 0 0 0 16.198 8.5h2.604A2.7 2.7 0 0 0 21.5 5.802v-.604A2.7 2.7 0 0 0 18.802 2.5M18.802 11.5h-2.604a2.7 2.7 0 0 0-2.698 2.698v4.604a2.7 2.7 0 0 0 2.698 2.698h2.604a2.7 2.7 0 0 0 2.698-2.698v-4.604a2.7 2.7 0 0 0-2.698-2.698M7.802 2.5H5.198A2.7 2.7 0 0 0 2.5 5.198v4.604A2.7 2.7 0 0 0 5.198 12.5h2.604A2.7 2.7 0 0 0 10.5 9.802V5.198A2.7 2.7 0 0 0 7.802 2.5"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDashboardFilled);
export default ForwardRef;
